var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2DataEvolution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v11.85l-4.25-4.57-18.67 21.19-21.37-21.68L7.5 49.17l-2.91-2.74L25.64 24l21.28 21.6L63 27.34 59 23h11zM51 64h4V49.48l-4 4.22V64zm4-53.94h-4v26.3l4-4.25V10.06zM40 64h4V53.36l-4-3.81V64zm4-53.94h-4v22.78l4 3.82v-26.6zM29 64h4V42.88l-4-3.81V64zm4-53.94h-4v12.3l4 3.82V10.06zM18 64h4V38.37l-4 4V64zm4-53.94h-4v15.35l4-4V10.06z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Data_evolution.7dca030c.svg";
export { SvgJ2DataEvolution as ReactComponent };